// src/components/Header.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FiHome, FiInfo, FiUserPlus, FiHelpCircle } from 'react-icons/fi'; // Added FiHelpCircle

const Header = () => (
  <header
    style={{
      backgroundColor: '#1B3B6F',
      color: 'white',
      padding: '1rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      position: 'relative',
    }}
  >
    {/* FAQs Button - Top Left */}
    <div style={{ position: 'absolute', top: '1rem', left: '1rem', zIndex: 10 }}>
      <Link
        to="/faqs"
        style={{
          backgroundColor: 'red',
          color: 'black',
          padding: '0.5rem 1rem',
          borderRadius: '5px',
          textDecoration: 'none',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          fontWeight: 'bold',
        }}
      >
        <FiHelpCircle /> FAQs
      </Link>
    </div>

    {/* Centered Title */}
    <h1 style={{ flex: 1, textAlign: 'center', margin: 0 }}>USIU Asset Recovery</h1>

    {/* Navigation Buttons */}
    <nav style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', justifyContent: 'center' }}>
      {/* Home */}
      <Link
        to="/"
        style={{
          backgroundColor: 'red',
          color: 'black',
          padding: '0.5rem 1rem',
          borderRadius: '5px',
          textDecoration: 'none',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          fontWeight: 'bold',
        }}
      >
        <FiHome /> Home
      </Link>

      {/* About Us */}
      <Link
        to="/about"
        style={{
          backgroundColor: 'grey',
          color: 'white',
          padding: '0.5rem 1rem',
          borderRadius: '5px',
          textDecoration: 'none',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          fontWeight: 'bold',
        }}
      >
        <FiInfo /> About Us
      </Link>

      {/* Sign Up */}
      <Link
        to="/signup"
        style={{
          backgroundColor: 'white',
          color: '#1B3B6F',
          padding: '0.5rem 1rem',
          borderRadius: '5px',
          textDecoration: 'none',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          fontWeight: 'bold',
        }}
      >
        <FiUserPlus /> Sign Up
      </Link>
    </nav>
  </header>
);

export default Header;
